import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const checkWarehouseLayoutVersion = {
  name: "checkWarehouseLayoutVersion" as const,
  input: z.object({ layoutId: zExt.objectId() }),
  output: z.object({ updatedAt: z.date().nullish() }),
};
